export default __webpack_public_path__ + "static/media/25.68e06d4d.jpg";